import CompanyService from "@/services/api/CompanyService";
import { useState } from "react";

const useCompanies = () => {
  const [companies, setCompanies] = useState<CompanyDTO[]>([]);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);

  const getCompanies = (params?: { name?: string } & Pageable): Promise<Page<CompanyDTO>> => {
    return new Promise((resolve, reject) => {
      CompanyService.getCompanies(params)
        .then((page) => {
          setCompanies(page.content);
          setTotalPages(page.totalPages);
          setTotalElements(page.totalElements);
          resolve(page);
        })
        .catch(reject);
    });
  };

  const getCompanyById = (id: string): Promise<CompanyWithUsersDTO> => {
    return CompanyService.getCompanyById(id);
  };

  const createCompany = (name: string): Promise<CompanyDTO> => {
    return CompanyService.createCompany({ name });
  };

  const deleteCompany = (id: string): Promise<void> => {
    return CompanyService.deleteCompany(id);
  };

  return {
    companies,
    totalPages,
    totalElements,
    getCompanies,
    getCompanyById,
    createCompany,
    deleteCompany,
  };
};

export default useCompanies;
